import { useAuthContext } from 'components/auth';
import { Modal } from 'components/ui';
import { BILLING_METHODS } from 'lib/constants';
import { parseFullName } from 'lib/helpers/greetingHelper';
import { useToast } from 'lib/hooks';
import { MarketingCompanySize } from 'lib/types/company';
import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { getChiliPiperBookingUrl } from './api';
import { getMarketingCompanySize } from './helpers';
import { useSalesRequestContext } from './SalesRequestContext';
import css from './SalesRequestModal.module.scss';

const BILLING_METHOD_TO_REQUEST_TYPE = {
  [BILLING_METHODS.CREDIT_CARD]: 'Stripe Customer',
  [BILLING_METHODS.INVOICE]: 'Invoice Customer',
};

export interface ISalesRequestModalProps {
  interest?: string;
  isVisible: boolean;
  onHide: () => void;
}

export const SalesRequestModal = ({
  isVisible,
  onHide,
}: ISalesRequestModalProps) => {
  const { message } = useToast();
  const { session } = useAuthContext();
  const { companySize, interest } = useSalesRequestContext();

  const [iframeUrl, setIframeUrl] = useState<string>();

  const handleResponseUrl = (urlString: string) => {
    const url = new URL(urlString);
    url.searchParams.append('hide_x', 'true');
    setIframeUrl(url.toString());
  };

  const initialize = async () => {
    try {
      const { firstName, lastName } = parseFullName(session.user.name);
      const response = await getChiliPiperBookingUrl({
        firstName,
        lastName,
        email: session.user.primaryEmail,
        companySize:
          getMarketingCompanySize(companySize) ||
          MarketingCompanySize.FIFTY_TO_NINETY_NINE,
        interest,
        billingMethod:
          BILLING_METHOD_TO_REQUEST_TYPE[session.company.billingMethod],
      });
      handleResponseUrl(response.url);
    } catch (e) {
      message.error('Something went wrong. Please try again later.');
      onHide();
    }
  };

  useEffect(() => {
    if (isVisible) {
      initialize();
    } else {
      setIframeUrl(undefined);
    }
  }, [isVisible]);

  return (
    <Modal className={css.modal} onHide={onHide} show={isVisible}>
      <Modal.Header>
        <Modal.Title>Talk To Sales</Modal.Title>
      </Modal.Header>
      <Modal.Body className="h-100">
        {iframeUrl ? (
          <iframe
            src={iframeUrl}
            title="Talk To Sales"
            className={css.iframe}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading sales request form</span>
            </Spinner>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
